import React, { useEffect, useState } from 'react';
import { Card, Divider, Row, Col, Space, Statistic, Typography } from 'antd';
import { percentReturn } from '../../utils/math';
import PnL from '../../components/PnL';
import { getIndexName } from '../../utils/abbreviations';
import { TrendUpIcon, TrendDownIcon } from '../../components/Icons';

const VolatilitySummaryCard = ({ timeSeriesData }) => {
  const [contangoStatus, setContangoStatus] = useState('N/A');
  const [volatilitySummary, setVolatilitySummary] = useState([]);

  useEffect(() => {
    if (timeSeriesData.length > 0) {
      const vixData = timeSeriesData.find(data => data.name === '^vix');
      const vix6mData = timeSeriesData.find(data => data.name === '^vix6m');
      const vix9dData = timeSeriesData.find(data => data.name === '^vix9d');

      if (vixData && vix6mData) {
        const latestVixClose = vixData.y[vixData.y.length - 1];
        const latestVix6mClose = vix6mData.y[vix6mData.y.length - 1];
        setContangoStatus(latestVix6mClose > latestVixClose ? 'Contango' : 'Backwardation');
      }

      const summaryData = [vixData, vix9dData, vix6mData].filter(Boolean).map(data => {
        const latestClose = data.y[data.y.length - 1];
        const changePercent = percentReturn(data.y[data.y.length - 8], latestClose);
        return {
          symbol: data.name,
          level: latestClose || 'N/A',
          changePercent,
        };
      });
      setVolatilitySummary(summaryData);
    }
  }, [timeSeriesData]);

  const icon = contangoStatus === 'Contango' ? <TrendUpIcon /> : <TrendDownIcon />;

  return (
    <Card bordered={false}>
      <Row gutter={[24, 24]} align="middle" justify="space-between">
        <Col span={12}>
          <Typography.Text style={{ fontSize: '1.35rem', color: 'var(--colored-text-1)', fontWeight: '300', textTransform: 'uppercase' }}>Volatility Structure</Typography.Text>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Space>
            {icon} <Typography.Text style={{ fontSize: '2rem', color: contangoStatus === 'Contango' ? 'var(--blue)':'var(--red)' }}>{contangoStatus}</Typography.Text>

          </Space>
        </Col>
      </Row>
      <Divider/>
      {/* Ticker Cards at the top */}
      <Row gutter={[24, 24]} justify="center">
        {volatilitySummary.map(({ symbol, level, changePercent }) => (
          <Col span={8} key={symbol} >
            <Card bordered={true} className={'gapless py-1 pr-1 pl-3'}>
              <Statistic
                title={<Typography.Text strong style={{ fontSize: '0.8rem', textAlign: 'left' }}>{getIndexName(symbol)}</Typography.Text>}
                value={level}
                prefix={'$'}
                precision={2}
                valueStyle={{ color: 'var(--colored-text-1)', fontSize: '1.5rem', fontWeight: '300' }}
              />
              <Typography.Text style={{ fontSize: '0.8rem' }}>
                This Week <PnL value={changePercent} />
              </Typography.Text>
            </Card>
          </Col>
        ))}
      </Row>
      <Divider/>

      {/* Contango/Backwardation status below ticker cards */}
    </Card>
  );
};

export default VolatilitySummaryCard;
